import { useUser } from '@liveblocks/react'

import { useAuth } from '@dc-shared-web/providers/AuthProvider'
import { cn } from '@dc-shared-web/lib'

export default function Mention({
  userId,
  className,
}: {
  userId: string
  className?: string
}) {
  const { isAuthenticating } = useAuth()
  const { user: liveblocksUser, isLoading } = useUser(userId)

  return (
    <span
      className={cn('lb-name lb-user', className)}
      data-loading={isLoading ? '' : undefined}
    >
      @
      {isAuthenticating || isLoading
        ? null
        : liveblocksUser?.name ?? 'Anonymous'}
    </span>
  )
}
